module.exports = __webpack_public_path__ + "img/company-document.fe07ff3f.svg";